import TopFirstView from 'components/top/TopFirstView'
import TopCaseStudy from 'components/top/TopCaseStudy'
import TopServices from 'components/top/TopServices'
import TopStrengths from 'components/top/TopStrengths'
import TopMedia from 'components/top/TopMedia'
import TopDLMM from 'components/top/TopDLMM'
import FooterCTA from 'components/common/FooterCTA'

const Template: React.FC = () => {
  return (
    <>
      <main>
        <TopFirstView />
        <TopCaseStudy />
        <TopServices />
        <TopStrengths />
        <TopMedia />
        <TopDLMM />
      </main>
      <FooterCTA />
    </>
  )
}

export default Template
